import React from "react";
//#region redux
import { useDispatch } from "react-redux";
import { selfInvoiceDiscarded } from "store/actions/selfInvoiceActions";
//#endregion
//#region types
import { AuthEnums, StyleEnums } from "models/enums";
import { SelfInvoiceWizardMoreActionsProps } from "models/propTypes/selfInvoicePropTypes";
import { MoreActionMenuItemType } from "models/propTypes/menuPropTypes";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import { MoreActions, useNavigationHistory } from "components/common";
import { useInvoiceService, useSelfInvoiceService } from "serviceHooks";
import { useLocation } from "react-router-dom";
//#endregion
import { CompanyService } from "services";
import { LocalizationHelperInstance } from "utils/helpers";

const SelfInvoiceWizardMoreActions: React.FC<SelfInvoiceWizardMoreActionsProps> = ({
  id,
  draftCustomerInvoiceId,
  reloadHandler,
  disableSuccessMessages,
}) => {
  const selfInvoiceService = useSelfInvoiceService();
  const invoiceService = useInvoiceService();

  const dispatch = useDispatch();

  const location = useLocation();
  const { goBack } = useNavigationHistory();

  const onReject = async () => selfInvoiceService.reject(id);

  const onRejectSuccess = () => {
    const reload = () => {
      if (location.pathname.includes("/SelfInvoice")) {
        goBack();
      } else {
        reloadHandler();
      }
    };

    dispatch(selfInvoiceDiscarded(id));
    if (draftCustomerInvoiceId) {
      invoiceService.deleteInvoice(draftCustomerInvoiceId).finally(() => reload());
    } else {
      reload();
    }
  };

  const discardAction: MoreActionMenuItemType = {
    description: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Reject),
    icon: IconDefinitionConstants.WEdit,
    onClickHandler: onReject,
    successMessage: TranslationKeys.Invoice.RejectSuccessMessage,
    highlightType: StyleEnums.DisplayType.Danger,
    inProgressMessage: TranslationKeys.Common.Saving,
    onActionSuccess: onRejectSuccess,
  };

  const getMenuItems = (): MoreActionMenuItemType[] => {
    const actions: MoreActionMenuItemType[] = [];
    if (!CompanyService.hasRelation(AuthEnums.PersonCompanyRelationType.Auditor)) {
      actions.push(discardAction);
    }
    return actions;
  };

  return <MoreActions menuItems={getMenuItems()} disableSuccessMessages={disableSuccessMessages} />;
};

export default SelfInvoiceWizardMoreActions;
